import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, DownloadIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, AreaChart, Area } from 'recharts';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Tabs } from '../../components/ui/Tabs';
import { StatCard } from '../../components/ui/StatCard';
import { formatVND, formatVNDCompact } from '../../lib/formatters';
import { MOCK_DASHBOARD_STATS, MOCK_MEMBER_GROWTH, MOCK_DEPOSIT_TRENDS, MOCK_CREDIT_USAGE } from '../../lib/mockData';
import { UsersIcon, WalletIcon, CreditCardIcon, TrendingUpIcon } from 'lucide-react';
export function ReportsPage() {
  const [activeTab, setActiveTab] = useState('members');
  const stats = MOCK_DASHBOARD_STATS;
  const tabs = [{
    id: 'members',
    label: 'Thành viên'
  }, {
    id: 'financial',
    label: 'Tài chính'
  }, {
    id: 'purchases',
    label: 'Mua hàng'
  }];
  return <div data-id="element-910">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-911">
        <div className="flex items-center justify-between mb-6" data-id="element-912">
          <div data-id="element-913">
            <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-914">
              <BarChart3Icon className="w-7 h-7 text-[#C8A84E]" data-id="element-915" />
              Báo Cáo
            </h1>
            <p className="text-sm text-[#666666]" data-id="element-916">Phân tích dữ liệu hệ thống</p>
          </div>
          <Button variant="secondary" size="sm" data-id="element-917">
            <DownloadIcon className="w-4 h-4" data-id="element-918" />
            Xuất Báo Cáo
          </Button>
        </div>
      </motion.div>

      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} className="mb-6" data-id="element-919" />

      {activeTab === 'members' && <div className="space-y-6" data-id="element-920">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-921">
            <StatCard label="Tổng thành viên" value={stats.totalMembers.toLocaleString('vi-VN')} icon={<UsersIcon className="w-5 h-5" data-id="element-923" />} trend={{
          value: 8.5,
          isPositive: true
        }} data-id="element-922" />
            <StatCard label="Hoạt động 30 ngày" value={stats.activeMembers30d.toLocaleString('vi-VN')} icon={<TrendingUpIcon className="w-5 h-5" data-id="element-925" />} data-id="element-924" />
            <StatCard label="Hoạt động 60 ngày" value={stats.activeMembers60d.toLocaleString('vi-VN')} icon={<TrendingUpIcon className="w-5 h-5" data-id="element-927" />} data-id="element-926" />
            <StatCard label="Hoạt động 90 ngày" value={stats.activeMembers90d.toLocaleString('vi-VN')} icon={<TrendingUpIcon className="w-5 h-5" data-id="element-929" />} data-id="element-928" />
          </div>
          <Card title="Tăng Trưởng Thành Viên" data-id="element-930">
            <div className="h-72" data-id="element-931">
              <ResponsiveContainer width="100%" height="100%" data-id="element-932">
                <AreaChart data={MOCK_MEMBER_GROWTH} data-id="element-933">
                  <CartesianGrid strokeDasharray="3 3" stroke="#2A2A2A" data-id="element-934" />
                  <XAxis dataKey="label" tick={{
                fill: '#666666',
                fontSize: 12
              }} axisLine={{
                stroke: '#2A2A2A'
              }} data-id="element-935" />
                  <YAxis tick={{
                fill: '#666666',
                fontSize: 12
              }} axisLine={{
                stroke: '#2A2A2A'
              }} data-id="element-936" />
                  <Tooltip contentStyle={{
                backgroundColor: '#1A1A1A',
                border: '1px solid #2A2A2A',
                borderRadius: 8,
                color: '#fff'
              }} data-id="element-937" />
                  <Area type="monotone" dataKey="value" stroke="#C8A84E" fill="#C8A84E" fillOpacity={0.1} name="Thành viên" data-id="element-938" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </div>}

      {activeTab === 'financial' && <div className="space-y-6" data-id="element-939">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-940">
            <StatCard label="Tổng nạp" value={formatVNDCompact(stats.totalDeposited)} icon={<WalletIcon className="w-5 h-5" data-id="element-942" />} trend={{
          value: 12.3,
          isPositive: true
        }} data-id="element-941" />
            <StatCard label="Thưởng phát hành" value={formatVNDCompact(stats.totalBonusIssued)} icon={<WalletIcon className="w-5 h-5" data-id="element-944" />} data-id="element-943" />
            <StatCard label="Đã sử dụng" value={formatVNDCompact(stats.totalCreditsRedeemed)} icon={<CreditCardIcon className="w-5 h-5" data-id="element-946" />} data-id="element-945" />
            <StatCard label="Nợ chưa dùng" value={formatVNDCompact(stats.unredeemedLiability)} icon={<CreditCardIcon className="w-5 h-5" data-id="element-948" />} data-id="element-947" />
          </div>
          <Card title="Xu Hướng Nạp Tiền" data-id="element-949">
            <div className="h-72" data-id="element-950">
              <ResponsiveContainer width="100%" height="100%" data-id="element-951">
                <BarChart data={MOCK_DEPOSIT_TRENDS} data-id="element-952">
                  <CartesianGrid strokeDasharray="3 3" stroke="#2A2A2A" data-id="element-953" />
                  <XAxis dataKey="label" tick={{
                fill: '#666666',
                fontSize: 12
              }} axisLine={{
                stroke: '#2A2A2A'
              }} data-id="element-954" />
                  <YAxis tick={{
                fill: '#666666',
                fontSize: 12
              }} axisLine={{
                stroke: '#2A2A2A'
              }} tickFormatter={v => formatVNDCompact(v)} data-id="element-955" />
                  <Tooltip contentStyle={{
                backgroundColor: '#1A1A1A',
                border: '1px solid #2A2A2A',
                borderRadius: 8,
                color: '#fff'
              }} formatter={(v: number) => [formatVND(v), 'Nạp tiền']} data-id="element-956" />
                  <Bar dataKey="value" fill="#C8A84E" radius={[4, 4, 0, 0]} data-id="element-957" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>
          <Card title="Sử Dụng Tín Dụng" data-id="element-958">
            <div className="h-72" data-id="element-959">
              <ResponsiveContainer width="100%" height="100%" data-id="element-960">
                <LineChart data={MOCK_CREDIT_USAGE} data-id="element-961">
                  <CartesianGrid strokeDasharray="3 3" stroke="#2A2A2A" data-id="element-962" />
                  <XAxis dataKey="label" tick={{
                fill: '#666666',
                fontSize: 12
              }} axisLine={{
                stroke: '#2A2A2A'
              }} data-id="element-963" />
                  <YAxis tick={{
                fill: '#666666',
                fontSize: 12
              }} axisLine={{
                stroke: '#2A2A2A'
              }} tickFormatter={v => formatVNDCompact(v)} data-id="element-964" />
                  <Tooltip contentStyle={{
                backgroundColor: '#1A1A1A',
                border: '1px solid #2A2A2A',
                borderRadius: 8,
                color: '#fff'
              }} formatter={(v: number) => formatVND(v)} data-id="element-965" />
                  <Line type="monotone" dataKey="value" stroke="#C8A84E" strokeWidth={2} name="Đã dùng" data-id="element-966" />
                  <Line type="monotone" dataKey="value2" stroke="#22C55E" strokeWidth={2} name="Nạp mới" data-id="element-967" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </div>}

      {activeTab === 'purchases' && <div className="space-y-6" data-id="element-968">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-969">
            <StatCard label="Doanh thu thành viên" value={formatVNDCompact(stats.memberRevenue)} icon={<TrendingUpIcon className="w-5 h-5" data-id="element-971" />} data-id="element-970" />
            <StatCard label="Doanh thu không TV" value={formatVNDCompact(stats.nonMemberRevenue)} icon={<TrendingUpIcon className="w-5 h-5" data-id="element-973" />} data-id="element-972" />
            <StatCard label="Tỷ lệ mua lại" value={`${stats.repeatPurchaseRate}%`} icon={<TrendingUpIcon className="w-5 h-5" data-id="element-975" />} trend={{
          value: 3.1,
          isPositive: true
        }} data-id="element-974" />
            <StatCard label="Giỏ hàng TB" value={formatVNDCompact(stats.averageBasketSize)} icon={<TrendingUpIcon className="w-5 h-5" data-id="element-977" />} data-id="element-976" />
          </div>
          <Card title="Doanh Thu Thành Viên vs Không Thành Viên" data-id="element-978">
            <div className="flex items-center justify-center gap-8 py-12" data-id="element-979">
              <div className="text-center" data-id="element-980">
                <p className="text-3xl font-bold text-[#C8A84E]" data-id="element-981">
                  {formatVNDCompact(stats.memberRevenue)}
                </p>
                <p className="text-sm text-[#B0B0B0] mt-1" data-id="element-982">Thành viên</p>
                <p className="text-xs text-[#666666]" data-id="element-983">
                  {Math.round(stats.memberRevenue / (stats.memberRevenue + stats.nonMemberRevenue) * 100)}
                  %
                </p>
              </div>
              <div className="w-px h-16 bg-[#2A2A2A]" data-id="element-984" />
              <div className="text-center" data-id="element-985">
                <p className="text-3xl font-bold text-[#B0B0B0]" data-id="element-986">
                  {formatVNDCompact(stats.nonMemberRevenue)}
                </p>
                <p className="text-sm text-[#B0B0B0] mt-1" data-id="element-987">Không thành viên</p>
                <p className="text-xs text-[#666666]" data-id="element-988">
                  {Math.round(stats.nonMemberRevenue / (stats.memberRevenue + stats.nonMemberRevenue) * 100)}
                  %
                </p>
              </div>
            </div>
          </Card>
        </div>}
    </div>;
}